/* Senha forte — a mesma regra no cadastro e na redefinição, no painel e na
   loja pública: 8+ caracteres, com letra maiúscula, número e símbolo.
   O servidor confere a redefinição com a mesma regra
   (functions/security/senha.js → confirmarResetSenha). */
export const REQUISITOS_SENHA = [
  ["8 caracteres",  s => s.length >= 8],
  ["Uma maiúscula", s => /[A-Z]/.test(s)],
  ["Um número",     s => /\d/.test(s)],
  ["Um símbolo",    s => /[^A-Za-z0-9]/.test(s)],
];

export const senhaForte = senha => REQUISITOS_SENHA.every(([, ok]) => ok(String(senha || "")));

export const MENSAGEM_SENHA_FRACA = "A senha precisa ter no mínimo 8 caracteres, com letra maiúscula, número e símbolo.";
